import Dashboard from "../../../../common/components/layout/Dashboard";
import Toast from "../../../../common/components/ui/toast";
import { ToastProvider } from "../../../../common/components/ui/toast/toast.provider";
import TrafficFinesDetailsPage from "../TrafficFinesDetailsPage";

export default function TrafficFineDetailsView() {

  return (
    <ToastProvider>
      <Dashboard>
        <TrafficFinesDetailsPage />
      </Dashboard>
      <Toast />
    </ToastProvider>
  );
}
